// removed by extract-text-webpack-plugin
module.exports = {"catalog-grid":"catalog-grid___IQeKs","card":"card___3dX00"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogCard/CatalogGrid.scss
// module id = VqFm
// module chunks = 57